const URL = {
  GET_BADGES: 'badge/list',
  CUSTOM_BADGE: 'CustomBadge',
  CUSTOM_BADGE_CREATE: 'CustomBadge/create',
}

export default URL
